import {
  GetPurgeScheduleResponse,
  IdUser,
} from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const getPurgeScheduleByUserId = (
  req: Partial<IdUser>
): Promise<GetPurgeScheduleResponse> =>
  request({
    url: '/service/userv2service/GetPurgeScheduleByUserId',
    body: req,
  }).then((r) => r.body);
